export default __webpack_public_path__ + "static/sub-logo-jp-69943b7398d8439fac0434309a6b583c.png";